//useSubcription.js
import { useEffect, useState } from "react";
import { db } from "../firebase/config";
import { useAuth } from "../Context/AuthContext";
import { doc, getDoc } from "firebase/firestore";

export function useSubscription() {
  const { user } = useAuth();
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setSubscription(null);
      setLoading(false);
      return;
    }

    const run = async () => {
      try {
        const userSnap = await getDoc(doc(db, `users/${user.uid}`));
        const companyId = userSnap.data()?.companyId;

        if (!companyId) {
          setSubscription(null);
          setLoading(false);
          return;
        }

        const companySnap = await getDoc(doc(db, `companies/${companyId}`));
        const companyData = companySnap.data() || {};

        // ✅ your single source of truth
        setSubscription(companyData.subscription || null);
      } catch (e) {
        console.error("useSubscription error:", e);
        setSubscription(null);
      } finally {
        setLoading(false);
      }
    };

    run();
  }, [user]);

  return { subscription, loading };
}
